import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./Header.scss";
import { SITE_CONFIG, ROUTES } from "./constants";
import { useAuth } from "./contexts/AuthContext";
import { useMessages } from "./contexts/MessagesContext";
import { getMenuItems } from "./utils/menuItems";

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, logout } = useAuth();
  const { unreadCount } = useMessages();
  const menuItems = getMenuItems();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const handleLogoClick = (e: React.MouseEvent) => {
    e.preventDefault();
    window.location.href = SITE_CONFIG.FRONTEND_URL;
  };

  const handleMenuClick = (path: string) => {
    navigate(path);
    closeMenu();
  };

  const handleLogout = async () => {
    await logout();
    navigate(ROUTES.HOME, { replace: true });
    closeMenu();
  };

  const isActive = (path: string) => 
    path === ROUTES.DASHBOARD 
      ? location.pathname === ROUTES.DASHBOARD 
      : location.pathname.startsWith(path);

  return (
    <header className="header">
      <div className="header-container">
        <div className="logo">
          <a href={SITE_CONFIG.FRONTEND_URL} onClick={handleLogoClick}>
            <img
              src="/img/oflogo.webp"
              alt="Mecenaso.pl"
              className="logo-icon"
            />
          </a>
        </div>

        {isAuthenticated && (
          <div
            className={`hamburger ${isMenuOpen ? "active" : ""}`}
            onClick={toggleMenu}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        )}

        {isAuthenticated && (
          <nav className={`nav ${isMenuOpen ? "active" : ""}`}>
            <ul className="nav-list">
              {menuItems.map((item) => (
                <li key={item.id}>
                  <button
                    onClick={() => handleMenuClick(item.path)}
                    className={`nav-link ${isActive(item.path) ? 'active' : ''}`}
                  >
                    <span className="nav-link-icon">{item.icon}</span>
                    <span className="nav-link-label">{item.label}</span>
                    {item.id === 'messages' && unreadCount > 0 && (
                      <span className="nav-link-badge">{unreadCount}</span>
                    )}
                  </button>
                </li>
              ))}
              <li>
                <button
                  onClick={handleLogout}
                  className="nav-link nav-link-logout"
                >
                  <svg className="nav-link-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16 17V14H9V10H16V7L21 12L16 17ZM14 2C15.1 2 16 2.9 16 4V6H14V4H5V20H14V18H16V20C16 21.1 15.1 22 14 22H5C3.9 22 3 21.1 3 20V4C3 2.9 3.9 2 5 2H14Z" fill="currentColor"/>
                  </svg>
                  <span className="nav-link-label">Wyloguj się</span>
                </button>
              </li>
            </ul>
          </nav>
        )}
      </div>
    </header>
  );
}
